module.exports = __webpack_public_path__ + "static/media/MarinaCiavatta.dc96d13c.png";